import React, { useEffect } from "react"
import { Box, Skeleton } from "@mui/material"
import { formatDate, isEmpty } from "@ui-seeker/utils"
import { AppDialogBody, AppDialogHeader } from "@components"
import { dateFormatReceiver } from "@utils"
import { useReportInfoModal } from "Pages/ReportsAlerts/Reports/@hooks"
import ReportInfoModalTabs from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/Tabs"
import ReportInfoModalDetails from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/Details"
import { INFO_MODAL_TABS, REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"
import { selectedInfoModalTab, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import ReportListHistoricalModal from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History"
import RatingHistoricalContent from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History/RatingContent"


const lastRun = data => {
	const timestamp = data?.timestampLastExecutionUser || data?.timestampLastExecution
	if (!timestamp) return 'Report info · not executed yet'
	return `Report info · last run ${formatDate(timestamp, { isString: true, format: 'dd MMM yyyy HH:mm', receivedFormat: dateFormatReceiver(timestamp) })}`
}


export default function ReportInfoModalContent({ onClose }) {


	const { data, isLoading, setIsLoading } = useReportInfoModal()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const hasData = !isLoading && !isEmpty(data)

	useEffect(() => {
		setIsLoading()
	}, [])

	return <>
		<AppDialogHeader
			icon="file-lines"
			title={data?.name}
			subtitle={hasData && lastRun(data)}
			onClose={onClose}
			loading={isLoading}
			sx={{ pb: 1 }}
		/>
		{hasData && <ReportInfoModalTabs timestampLastExecution={data?.timestampLastExecution}/>}
		<AppDialogBody sx={{ pt: 2.5, minHeight: '50vh' }}>
			{isLoading && <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1.5 }}>
				{[0, 1, 2, 3].map(idx => <Skeleton key={idx} variant="rounded" height={62}/>)}
				<Skeleton variant="rounded" height={260} sx={{ gridColumn: '1 / -1' }}/>
			</Box>}
			{hasData && selectedInfoModalTab.value === INFO_MODAL_TABS.DETAILS && <ReportInfoModalDetails data={data}/>}
			{hasData && selectedInfoModalTab.value === INFO_MODAL_TABS.HISTORY && (isRating
				? <RatingHistoricalContent idReport={data.idReport}/>
				: <ReportListHistoricalModal idReport={data.idReport}/>
			)}
		</AppDialogBody>
	</>

}
